module.exports = __webpack_public_path__ + "static/media/employee-navigator.eba43823.png";